var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconMonitor4K = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", stroke: props.color, strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", null,
                React.createElement("g", { transform: "translate(-1.083 -2.167)" },
                    React.createElement("path", { d: "M7.4,7.4h17.3c1.2,0,2.2,1,2.2,2.2v10.8c0,1.2-1,2.2-2.2,2.2H7.4c-1.2,0-2.2-1-2.2-2.2V9.6\n\t\t\tC5.2,8.4,6.2,7.4,7.4,7.4z" }),
                    React.createElement("path", { d: "M11.7,26.9h8.7" }),
                    React.createElement("path", { d: "M16.1,22.6v4.3" })),
                React.createElement("path", { d: "M13.1,17.2V8.5" }),
                React.createElement("path", { d: "M8.2,12.9V8.5" }),
                React.createElement("path", { d: "M13.1,12.9h-5" }),
                React.createElement("path", { d: "M17.2,16.9V8.2" }),
                React.createElement("path", { d: "M21.7,16.9l-3.8-3.8" }),
                React.createElement("path", { d: "M21.7,8.5l-3.8,3.8" })))));
});
export default IconMonitor4K;
//# sourceMappingURL=IconMonitor4K.js.map